const HTML_TAG_PATTERN = /<[a-z][^>]*>/i;

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function toRichHtml(text: string): string {
  if (HTML_TAG_PATTERN.test(text)) {
    return text;
  }
  return text
    .split('\n\n')
    .map(block => block.trim())
    .filter(Boolean)
    .map(block => `<p>${escapeHtml(block)}</p>`)
    .join('');
}
